// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"176":"projects","443":"about"}[chunkId] || chunkId) + "." + {"176":"34b01b89","209":"c55716d1","220":"a0273b95","443":"958f72c3","448":"55f62975","566":"854b9b70","692":"6f057862","788":"b64907aa","856":"1b799196","886":"60467afb","898":"2d1652d4"}[chunkId] + ".js";
};